module.exports = __webpack_public_path__ + "img/maur.97745b11.jpg";